// @flow
import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import "../css/Modal.css";

type Props = {
  fullScreen: boolean,
  className?: string,
  onClose?: () => void,
  children?: React.Node
};

class Modal extends React.Component<Props> {
  static defaultProps = {
    fullScreen: true,
    className: ''
  };

  onClose(e: any) {
    // console.log("close modal");
    e.stopPropagation();
    e.preventDefault();
    if(this.props.onClose !== undefined) {
      this.props.onClose();
    }
    return false;
  }

  render() {
    const className = "modal " + (this.props.fullScreen ? 'full-screen ' : '') + (this.props.className === undefined ? "" : this.props.className);
    return (
      <div className={className}>
        <div className="contents-wrapper">
          <div className='contents'>
            {this.props.children}
          </div>

          <div className='modal-buttons'>
            <a href='#' className="button right" onClick={this.onClose.bind(this)}><FormattedMessage id='close' defaultMessage='Cerrar' /></a>
          </div>
        </div>
      </div>
    );
  }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal.js